if (!customElements.get('product-routines-carousel')) {
    class ProductRoutinesCarousel extends HTMLElement {
        constructor() {
            super();

            this.sectionId = this.dataset.id
            this.contentSlider = new Splide( `#content-carousel-${this.sectionId}`,{
                gap: '1rem'
            })

            this.videoSliderDesktop = new Splide( `#video-carousel-desktop-${this.sectionId}`, {
                perPage: 1,
                gap: '1rem',
                arrows: false,
                pagination: false,
                focus: 'left',
                trimSpace: true,
                padding: {
                    right: '4rem'
                },
                disableOverlayUI: true,
                video: {
                    autoplay: true,
                    loop: true,
                    mute: true,
                    hideControls: true,
                    playerOptions: {
                        htmlVideo: {
                            playsInline: true,
                            autoplay: true,
                            loop: true,
                            muted: true,
                            autoplay: true
                        }
                    }
                },
                mediaQuery: 'min',
                breakpoints: {
                    750: {
                        perPage: 2,
                        drag: false
                    }
                }
            } )

            this.contentSlider.on('mounted', () => {
                this.contentSlider.Components.Slides.forEach((SlideComponent) => {
                    const slide = SlideComponent.slide
                    const mobileCTA = slide.querySelector('.product-routines-carousel__content--cta > button')
                    const hasMobileCTA = slide.querySelector('.product-routines-carousel__content--card-hidden')
                    if ( mobileCTA && hasMobileCTA ){
                        mobileCTA.addEventListener('click', () => {
                            hasMobileCTA.classList.toggle('product-routines-carousel__content--card-hidden')
                        })
                    }
                })
            })

            this.videoSliderMobile = new Splide( `#video-carousel-mobile-${this.sectionId}`, {
                video: {
                    autoplay: true,
                    loop: true,
                    mute: true,
                    hideControls: true,
                    playerOptions: {
                        htmlVideo: {
                            playsInline: true,
                            autoplay: true,
                            loop: true,
                            muted: true,
                            autoplay: true
                        }
                    }
                },
                perPage: 1,
                gap: '1rem',
                arrows: false,
                pagination: false,
                focus: 'center',
                trimSpace: true,
                padding: {
                    right: '2rem',
                    left: '2rem'
                },
                disableOverlayUI: true,
            } )

            const videoSliders = [this.videoSliderDesktop, this.videoSliderMobile]
            videoSliders.forEach(slider => {
                slider.on('mounted', () => {
                    slider.Components.Slides.forEach((SlideComponent) => {
                        const slide = SlideComponent.slide
                        const playPauseButton = slide.querySelector('.splide__video__play')
                        if (!playPauseButton) return
                        playPauseButton.innerHTML = `
                        <svg xmlns="http://www.w3.org/2000/svg"  width="auto" height="1.6rem" fill="white" class="bi bi-play" viewBox="0 0 16 16">
                            <path d="M10.804 8 5 4.633v6.734zm.792-.696a.802.802 0 0 1 0 1.392l-6.363 3.692C4.713 12.69 4 12.345 4 11.692V4.308c0-.653.713-.998 1.233-.696z"/>
                        </svg>
                        <svg width="auto" height="1rem" viewBox="0 0 6 10" fill="none" class="bi bi-pause" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 9.25641V1" stroke="white" stroke-width="1.5" stroke-linecap="round" />
                            <path d="M5.2002 9.25641V1" stroke="white" stroke-width="1.5" stroke-linecap="round" />
                        </svg>
                        `
                        const muteButton = document.createElement('button')
                        muteButton.className = 'splide__video__mute'
                        muteButton.setAttribute('type', 'button')
                        muteButton.setAttribute('aria-label', 'Mute Video')
                        muteButton.innerHTML = `
                        <svg xmlns="http://www.w3.org/2000/svg" width="auto" height="1rem" viewBox="0 0 16 13" fill="none">
                            <path d="M7.90074 0.766113L4.06699 3.78356H1V8.30972H4.06699L7.90074 11.3272V0.766113Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M11 8L15 4" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M11 4L15 8" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>`
                        muteButton.addEventListener('click', (e) => {
                            e.preventDefault()
                            e.stopPropagation()
                            const player = slide.querySelector('video')
                            if (player) {
                                player.muted = !player.muted
                            }
                        })
                        playPauseButton.parentNode.insertAdjacentElement('afterend', muteButton)
                    })
                })
            })

            // Both carousels hold the same slides and the same video file; CSS shows
            // one per breakpoint. Mounting both made Splide build a <video> in the
            // hidden one too -- display:none stops painting, not loading -- so the
            // file was fetched twice on every device. Park the video URL on the
            // hidden carousel so Splide skips it, and hand it back on a breakpoint
            // change.
            this.desktopQuery = window.matchMedia('(min-width: 750px)')
            this.parkHiddenVideos()

            this.contentSlider.sync( this.videoSliderDesktop )
            this.videoSliderDesktop.sync( this.videoSliderMobile )
            this.contentSlider.mount()
            this.videoSliderDesktop.mount( window.splide.Extensions )
            this.videoSliderMobile.mount( window.splide.Extensions )

            this.desktopQuery.addEventListener('change', () => {
                this.parkHiddenVideos()
                this.videoSliderDesktop.refresh()
                this.videoSliderMobile.refresh()
            })
        }

        // Keeps data-splide-html-video only on the carousel that is on screen.
        parkHiddenVideos() {
            const shown = this.desktopQuery.matches ? 'desktop' : 'mobile'
            const hidden = this.desktopQuery.matches ? 'mobile' : 'desktop'

            document.querySelectorAll(`#video-carousel-${shown}-${this.sectionId} [data-parked-video]`)
                .forEach((slide) => {
                    slide.setAttribute('data-splide-html-video', slide.dataset.parkedVideo)
                    slide.removeAttribute('data-parked-video')
                })

            document.querySelectorAll(`#video-carousel-${hidden}-${this.sectionId} [data-splide-html-video]`)
                .forEach((slide) => {
                    slide.setAttribute('data-parked-video', slide.dataset.splideHtmlVideo)
                    slide.removeAttribute('data-splide-html-video')
                })
        }
    }

    customElements.define('product-routines-carousel', ProductRoutinesCarousel);
}
